var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWsLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m35.84,0l-13.85,0.04l-11.52,19.97l6.89,11.99l18.48,-32z",
    fill: "#960145",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.2,0l-13.85,0.04l-11.52,19.97l6.89,11.99l18.48,-32z",
    fill: "#960145",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.47,0l-18.47,0l8.74,16.02l9.73,-16.02z",
    fill: "#960145",
    id: "svg_3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsLogoSmall);
export default __webpack_public_path__ + "static/media/ws-logo-small.7fbc5020625ab7d60662a6f3a4b40749.svg";
export { ForwardRef as ReactComponent };